import * as React from 'react';
import './styles.css';

interface ILinearProgressBar {
  percent: number;
  label: string;
  fontSize?: number;
  animateTiming?: number;
}

export function LinearProgressBar(props: ILinearProgressBar) {
  return (
    <div className={'mainProgressBarDiv'}>
      <span className={'progressLabel'} style={{paddingRight: '15px'}}>
        09:00
      </span>
      <div style={{flexGrow: 1}}>
        <span
          className={'percentage'}
          style={{
            fontSize: props.fontSize || 46,
            left: `calc(${props.percent}% - 55px)`,
            transition: '3s',
            position: 'relative'
          }}
        >
          {props.label} <br></br>{props.percent.toFixed(0)} %
        </span>
        <div className={'emptyProgressBar'} style={{width: '100%'}}>
          <div
            className={'fillingProgressBar'}
            style={{
              left: (props.percent - 100) + '%' ,
              transition: '3s'
            }}
          />
        </div>
      </div>
      <span className={'progressLabel'} style={{paddingLeft: '15px'}}>
        15:30
      </span>
    </div>
  );
}
